module.exports = __webpack_public_path__ + "static/media/icon-check-circle.ce63c045.svg";